import { Button } from '@/components/ui/Button';
import { ButtonProps } from '@mui/material/Button/Button';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip/Tooltip';
import { Fragment } from 'react';

export const ConfirmItemButton = ({
    tooltip,
    preventSpan,
    placement,
    ...rest
}: {
    tooltip?: string;
    preventSpan?: boolean;
    placement?: TooltipProps['placement'];
} & ButtonProps) => {
    const Container = preventSpan ? Fragment : 'span';

    if (rest.disabled) {
        return (
            <Tooltip title={tooltip} placement={placement}>
                {/* This <span/> wrapper is necessary as <Tooltip/> doesn't work when directly
                applied to a button if the button is disabled. */}
                <Container>
                    <Button color='primary' variant='contained' disableElevation {...rest} />
                </Container>
            </Tooltip>
        );
    }

    return (
        <Tooltip title={tooltip} placement={placement}>
            <Button color='primary' variant='contained' disableElevation {...rest} />
        </Tooltip>
    );
};
